import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";
import {Table} from "semantic-ui-react";

export default class ContractsVolumeTableHeader extends Component {

  static Layout = [
    { column: "date", name: "month" },
    { column: "baseTotalCapacity", name: "Total Capacity" },
    { column: "baseTradedCapacity", name: "Traded Capacity" },
    { column: "baseExposedCapacity", name: "Exposed Capacity" },
    { column: "baseTraded", name: "% Traded" },
    { column: "baseExposed", name: "% Exposed" },
    { column: "peakTotalCapacity", name: "Total Capacity" },
    { column: "peakTradedCapacity", name: "Traded Capacity" },
    { column: "peakExposedCapacity", name: "Exposed Capacity" },
    { column: "peakTraded", name: "% Traded" },
    { column: "peakExposed",name: "% Exposed" }
  ];

  render() {
    const structuredHeading = (<Table.Row>
      <Table.HeaderCell colSpan="1"></Table.HeaderCell>
      <Table.HeaderCell colSpan='5'>Baseload</Table.HeaderCell>
      <Table.HeaderCell colSpan='5'>Peak</Table.HeaderCell>
    </Table.Row>);

    return (
        <React.Fragment>
          <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ContractsVolumeTableHeader.Layout} structuredHeading={structuredHeading} />
        </React.Fragment>
    )
  }



}

